"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ILLUSTRATION_TYPES = exports.ILLUSTRATION_SIZES = void 0;
const ILLUSTRATION_SIZES = exports.ILLUSTRATION_SIZES = ['lg',
// scene
'md',
// dialog
'sm',
// spot
'xs' // dot
];
const ILLUSTRATION_TYPES = exports.ILLUSTRATION_TYPES = ['SimpleBalloon', 'BalloonSky', 'SimpleBell', 'SimpleCalendar', 'SimpleCheckMark', 'SimpleConnection', 'SimpleEmptyDoc', 'SimpleEmptyList', 'EmptyList', 'SimpleError', 'SimpleMagnifier', 'SimpleMail', 'SimpleNotFoundMagnifier', 'SimpleNoSavedItems', 'SimpleReload', 'SimpleTask', 'IllustratedFaceID', 'AddColumn', 'AddDimensions', 'AddPeople', 'Connection', 'EmptyCalendar', 'EmptyPlanningCalendar', 'ErrorScreen', 'FilterTable', 'GroupTable', 'NewMail', 'NoColumnsSet', 'NoDimensionsSet', 'NoFilterResults', 'NoMail', 'NoSavedItems', 'PageNotFound', 'ReloadScreen', 'ResizeColumn', 'SearchEarth', 'SearchFolder', 'SignOut', 'SleepingBell', 'SortColumn', 'SuccessHighFive', 'SuccessScreen', 'Tent', 'UnableToLoadImage', 'UploadCollection', 'UploadToCloud', 'Survey', 'NoTasks', 'Car', 'CarAlt', 'Hotel', 'HotelAlt', 'Kite', 'KiteAlt', 'Plane', 'PlaneAlt', 'Rail', 'RailAlt', 'Persona', 'Teams'];